export const setForms = (state, payload) => {
  state.forms = payload;
};

export const setSingleForm = (state, payload) => {
  state.single_form = payload;
};
